export default __webpack_public_path__ + "static/6877-b3241ba6e349fb00b340b889346e3c22.jpg";